import { render, staticRenderFns } from "./paper-score-report.vue?vue&type=template&id=bed33ed8"
import script from "./paper-score-report.vue?vue&type=script&lang=js"
export * from "./paper-score-report.vue?vue&type=script&lang=js"
import style0 from "./paper-score-report.vue?vue&type=style&index=0&id=bed33ed8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports